import React from 'react';
import PropTypes from 'prop-types';
import BasicDialog from 'shared/components/feedback/BasicDialog';

const NewLinkedConsultModal = ({ onConfirm, onCancel }) => (
  <BasicDialog
    title="Did you mean to link to an EEG that has been disconnected?"
    open
    confirmText="Yes"
    cancelText="No"
    handleConfirm={onConfirm}
    handleCancel={onCancel}
  />
);

NewLinkedConsultModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
};

export default NewLinkedConsultModal;
